var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view match",staticStyle:{"overflow-x":"scroll"}},[_c(_vm.activeView,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }